/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  
  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


(function($){





$('.header__nav-button').click(function(){

  $('body').toggleClass('open-menu')

  $('.menu').toggleClass('open')

})



$('.nav_element.dropdown>a').click(function(){

  $(this).toggleClass('open')

  $(this).next('.submenu').toggle(500)

})

if (screen.width < 992) {

  $(".nav_element.dropdown>a").attr("href", "javascript:;");

}



$('.scroll-down').on('click', function(e) {

                  

  e.preventDefault(); // prevent hard jump, the default behavior

  var target = $(this).attr("href"); // Set the target as variable

  console.log(target);



  $('html, body').stop().animate({

          scrollTop: $(target).offset().top - 50

  }, 600, function() {

          //location.hash = target; //attach the hash (#jumptarget) to the pageurl

          console.log($(target).offset().top);

  });



  return false;				

});





// $('.small-destinations .single-destinations').each(function(){

//   $(this).find('img:first').hide();

//   var _Bg = 'url('+ $(this).find('img:first').attr('src') + ')';

//   $(this).css("background-image", _Bg);

//   $(this).find('img:first').hide();

// });



$('.hero-slide').slick({

  dots: true,

  arrows: false,

  infinite: true,

  prevArrow:"<button type='button' class='slick-prev small-icon'><svg width='10' height='18' viewBox='0 0 10 18' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M9 17L1 9L9 1' stroke='CurrentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",

  nextArrow:"<button type='button' class='slick-next small-icon'><svg width='10' height='18' viewBox='0 0 10 18' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 17L9 9L1 1' stroke='CurrentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",

  slidesToShow:1

});



$('.logo-slide').slick({

  dots: false,

  arrows: true,

  infinite: true,

  prevArrow:"<button type='button' class='slick-prev small-icon'><svg width='10' height='18' viewBox='0 0 10 18' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M9 17L1 9L9 1' stroke='CurrentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",

  nextArrow:"<button type='button' class='slick-next small-icon'><svg width='10' height='18' viewBox='0 0 10 18' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 17L9 9L1 1' stroke='CurrentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",

  slidesToShow:6,



  responsive: [
    {

      breakpoint: 1200,

      settings: {

        slidesToShow: 5

      }

    },
    {

      breakpoint: 992,

      settings: {

        slidesToShow: 3

      }

    },

    {

      breakpoint: 640,

      settings: {

        slidesToShow: 2

      }

    }

  ]

});

  $('.gallery-slide').slick({

  dots: true,

  arrows: true,

  infinite: false,

  prevArrow:"<button type='button' class='slick-prev small-icon'><svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M45.7891 13C41.6394 5.82639 33.8833 1 24.9999 1C11.7451 1 1 11.7452 1 25C1 38.2548 11.7451 49 24.9999 49C33.8833 49 41.6394 44.1736 45.7891 37M25.0001 34.6L15.4001 25M15.4001 25L25.0001 15.4M15.4001 25H49' stroke='currentcolor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",

  nextArrow:"<button type='button' class='slick-next small-icon'><svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'> <path d='M4.21093 13C8.36062 5.82639 16.1167 1 25.0001 1C38.2549 1 49 11.7452 49 25C49 38.2548 38.2549 49 25.0001 49C16.1167 49 8.36063 44.1736 4.21093 37M24.9999 34.6L34.5999 25M34.5999 25L24.9999 15.4M34.5999 25H1' stroke='currentcolor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/> </svg></button>",

  slidesToShow:4,
 responsive: [
    {

      breakpoint: 1200,

      settings: {

        slidesToShow: 4

      }

    },
    {

      breakpoint: 992,

      settings: {

        slidesToShow: 3

      }

    },

    {

      breakpoint: 640,

      settings: {
 arrows: false,
        slidesToShow: 2

      }

    }

  ]

});



$('.h-blog-slide').slick({

  dots: false,

  arrows: true,

  infinite: true,

  prevArrow:"<button type='button' class='slick-prev small-icon'><svg width='10' height='18' viewBox='0 0 10 18' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M9 17L1 9L9 1' stroke='CurrentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",

  nextArrow:"<button type='button' class='slick-next small-icon'><svg width='10' height='18' viewBox='0 0 10 18' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 17L9 9L1 1' stroke='CurrentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",

  slidesToShow:4,



  responsive: [

    {

      breakpoint: 640,

      settings: {

        slidesToShow: 1

      }

    }

  ]

});



$('.testimonial_slide').slick({

  dots: false,

  arrows: true,

  infinite: true,

  prevArrow:"<button type='button' class='slick-prev small-icon'><svg width='10' height='18' viewBox='0 0 10 18' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M9 17L1 9L9 1' stroke='CurrentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",

  nextArrow:"<button type='button' class='slick-next small-icon'><svg width='10' height='18' viewBox='0 0 10 18' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 17L9 9L1 1' stroke='CurrentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",

  slidesToShow:1,



  responsive: [

    {

      breakpoint: 640,

      settings: {

        slidesToShow: 1

      }

    }

  ]

});



$('.tab-menu li a').on('click', function(){

  var target = $(this).attr('data-rel');

$('.tab-menu li a').removeClass('active');

  $(this).addClass('active');

  $("#"+target).fadeIn('slow').siblings(".tab-box").hide();

  return false;

});







      $('.latest_blog_big .single-blog-img ').each(function(){
  $(this).find('img').hide();
  var _Bg = 'url('+ $(this).find('img').attr('src') + ')';
  $(this).css("background-image", _Bg);
  $(this).find('img').hide();
});





$('.blog_nav li a').on('click', function(){

  var target = $(this).attr('data-rel');

$('.blog_nav li a').removeClass('active');

  $(this).addClass('active');

  $("#"+target).fadeIn('slow').siblings(".tab-box").hide();

  return false;

});

  
$('.section-tab-nav li a').on('click', function(){

  var target = $(this).attr('data-rel');

$('.section-tab-nav li a').removeClass('active');

  $(this).addClass('active');

  $("#"+target).fadeIn('slow').siblings(".tab-box").hide();

  return false;

});






$(document).ready(function() {



  const accordionItems = $(".accordion-item");







  accordionItems.each(function(index) {



    const header = $(this).find(".accordion-header");



    const content = $(this).find(".accordion-content");



    const arrow = $(this).find(".arrow");







    header.on("click", function() {



      const isOpen = $(this).parent().hasClass("open");







      if (!isOpen) {



        accordionItems.removeClass("open");



        accordionItems.find(".arrow").removeClass("open");



        accordionItems.find(".accordion-content").slideUp();



        



        $(this).parent().addClass("open");



        $(this).find(".arrow").addClass("open");



        content.slideDown();



      } else {



        $(this).parent().removeClass("open");



        $(this).find(".arrow").removeClass("open");



        content.slideUp();



      }



    });



  });







  // Open the first accordion item by default



  accordionItems.first().addClass("open");



  accordionItems.first().find(".arrow").addClass("open");



  accordionItems.first().find(".accordion-content").slideDown();



});





})(jQuery);





